import {
  GxButton,
  GxDropdown,
  GxIcon,
  GxInput,
  GxMenu,
  GxMenuDivider
} from '@garpix/garpix-web-components-react';
import classnames from 'classnames';
import cnBind from 'classnames/bind';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-multi-date-picker';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import Select, { SingleValue } from 'react-select';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import { SearchIcon, SettingsIcon} from '../../../../assets';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/CalendarIcon.svg';
import PencilIcon from '../../../../assets/icons/PencilIcon.svg';
import SelectUser from '../../../../components/SelectUsers/Select';
import Switcher from '../../../../components/Switcher';
import { months, weekDays } from '../../../../const/calendar';
import useModalFlag from '../../../../hooks/useModalFlag';
import { customStatusSelect } from '../../../Applications/consts';
import { getTaskDateActiveFilters } from '../../../Applications/helpers';
import {defaultFiltersValue, STATUS_TASK, TYPE_TASK, TYPE_TASK_TITLE} from '../../const';
import { IFilters, ILayoutFiltersOverlay } from '../../interfaces';
import Burger from '../../../../components/Burger';
import MultiSelectWithCheckboxes from '../CheckboxOption';
import styles from './styles/index.module.scss';

const FiltersOverlay: React.FC<ILayoutFiltersOverlay> = ({ children }) => {
  const navigate = useNavigate();
  const { dispatch, currentUser } = useStoreon<State, Events>('currentUser');
  const { flag: flagFiltersDate, setModalFlag: toggleFlagFiltersDate } = useModalFlag();
  const [dateFilterCount, setDateFilterCount] = useState<number>()

  const cn = cnBind.bind(styles);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 768px)'
  })
  const [filters, setFilters] = useState<IFilters>(defaultFiltersValue);

  const changeFilters = (params: any) => {
    if (params.isMine) {
      dispatch('taskInfo/set', { ...filters, ...params, isMine: true, page: 1});
    } else {
      dispatch('taskInfo/set', { ...filters, ...params, isMine: false, page: 1});
    }
    dispatch('tasks/get');
    setFilters({ ...filters, ...params, page: 1});
  }

  useEffect(() => {
    setDateFilterCount(getTaskDateActiveFilters(filters).length);
  }, [filters])

  const handleResetDateFilters = () => {
    const resetFilters = getTaskDateActiveFilters(filters).map(([key]) => [key, null]);
    dispatch('taskInfo/set', { ...filters, ...Object.fromEntries(resetFilters), page: 1 });
    dispatch('tasks/get');
    setFilters({ ...filters, ...Object.fromEntries(resetFilters) });
    toggleFlagFiltersDate()
  }

  const clearDate = (date:any) => {
    dispatch('taskInfo/set', { ...filters, ...date, page: 1 });
    dispatch('tasks/get');
    setFilters({ ...filters, ...date });
  }

  const handleClickResetFilters = () => {
    setFilters(defaultFiltersValue);
    dispatch('taskInfo/clear');
    dispatch('tasks/get')
  }
  function CustomRangeInput({ openCalendar, value }: any) {
    let date = `${dayjs(value).format('DD.MM.YYYY')}`;
    if (value === '') date = '- -- -';

    return (
      <div className={styles['calendar']} >
        <input
          readOnly
          value={date}
          className={styles['calendar--input']}
          onFocus={openCalendar} />
        <div role='button' tabIndex={0} onClick={openCalendar}>
          <CalendarIcon className={styles['button--icon_calendar']} />
        </div>
      </div>
    );
  }

  function FiltersDate() {
    return (
      <div className={styles['filters-date']}>
        <div className={styles['filters-date--info']}>
          <GxButton className={styles['button--filters-date']} onClick={toggleFlagFiltersDate}>
            <span className={cn({
              'button--filters-date__close': true,
              'button--filters-date__close-reverse': flagFiltersDate
            })}
            >
              Фильтрация по дате
            </span>
          </GxButton>
          {!!dateFilterCount &&
            <div className={styles['filters-date--info__item']}>
              <span>{dateFilterCount}</span>
              <span role='button' tabIndex={0} onClick={handleResetDateFilters} className={styles['filters-date--info__item_close']} />
            </div>
          }
        </div>
        {flagFiltersDate &&
          <div className={styles['filters-date--container']}>
            <label htmlFor="created_at" className={styles['filters-date--item']}>
              <span>Дата создания:</span>
              <DatePicker
                weekDays={weekDays}
                months={months}
                name='created_at'
                value={dayjs(filters.created_at,'DD.MM.YYYY').toDate()}
                weekStartDayIndex={1}
                onChange={(date: any) => changeFilters({ created_at: dayjs(date).format('DD.MM.YYYY') })}
                render={<CustomRangeInput />}
              />
              {filters.created_at &&
                <span
                  className={styles['filters-date--info__item_close']}
                  onClick={() => {
                    clearDate({created_at: null})
                  }}
                  role='button'
                  tabIndex={0}
                />
              }
            </label>
            <label htmlFor="start_at" className={styles['filters-date--item']}>
              <span>Дата начала работы:</span>
              <DatePicker
                weekDays={weekDays}
                months={months}
                value={dayjs(filters.start_at,'DD.MM.YYYY').toDate()}
                name="start_at"
                weekStartDayIndex={1}
                onChange={(date: any) => changeFilters({ start_at: dayjs(date).format('DD.MM.YYYY')  })}
                render={<CustomRangeInput />}
              />
              {filters.start_at &&
                <span
                  className={styles['filters-date--info__item_close']}
                  onClick={() => clearDate({start_at: null})}
                  role='button'
                  tabIndex={0}
                />
              }
            </label>
            <label htmlFor="closed_at" className={styles['filters-date--item']}>
              <span>Дата закрытия:</span>
              <DatePicker
                weekDays={weekDays}
                months={months}
                value={dayjs(filters.closed_at,'DD.MM.YYYY').toDate()}
                name="closed_at"
                weekStartDayIndex={1}
                onChange={(date: any) => changeFilters({ closed_at: dayjs(date).format('DD.MM.YYYY')  })}
                render={<CustomRangeInput />}
              />
              {filters.closed_at &&
                <span
                  className={styles['filters-date--info__item_close']}
                  onClick={() => clearDate({closed_at: null})}
                  role='button'
                  tabIndex={0}
                />
              }
            </label>
            <label htmlFor="deadline_at" className={styles['filters-date--item']}>
              <span>Дата дедлайна:</span>
              <DatePicker
                weekDays={weekDays}
                months={months}
                value={dayjs(filters.deadline_at,'DD.MM.YYYY').toDate()}
                name="deadline_at"
                weekStartDayIndex={1}
                onChange={(date: any) => changeFilters({ deadline_at: dayjs(date).format('DD.MM.YYYY') })}
                render={<CustomRangeInput />}
              />
              {filters.deadline_at &&
                <span
                  className={styles['filters-date--info__item_close']}
                  onClick={() => clearDate({deadline_at: null})}
                  role='button'
                  tabIndex={0}
                />
              }
            </label>
          </div>
        }
      </div>
    );
  }

  function Filters() {
    return (
      <>
        <label htmlFor='search-input' className={styles['search--group']}>
          <div className={styles['search--icon']}>
            <GxIcon src={SearchIcon} />
          </div>
          <GxInput placeholder='Название задачи' name='search-input' className={styles['search--input']} onGx-input={(e: any) => {
            dispatch('taskInfo/set', { search: e.target.value, page: 1 });
            dispatch('tasks/get');
          }} />
        </label>
        <SelectUser className={styles['select--group']} onChange={(e)=>{
          dispatch('taskInfo/set', { ...filters, user: String(e?.value), page: 1 });
          dispatch('tasks/get');
        }}/>
        <label htmlFor='select-task' className={styles['select--group']}>
          <span className={styles['select--title']}>Тип задачи:</span>
          <Select
            options={TYPE_TASK}
            value={filters.source ? (TYPE_TASK_TITLE[filters.source]) : TYPE_TASK[10]}
            styles={customStatusSelect}
            onChange={(e: SingleValue<{ value: number; label: string; }>) => {
              changeFilters({ source: e?.value === 10 ? undefined : e?.value })
            }}
          />
        </label>
        <label htmlFor='select-task' className={cn(styles['select--group'], styles['select--group_status'])}>
          <span className={cn(styles['select--title__status'], styles['select--title'])}>Статус:</span>
          <MultiSelectWithCheckboxes
          options={STATUS_TASK}
          value={STATUS_TASK.filter((task) => filters?.state?.includes(task.status))}
          onChange={(selectedOptions: any[]) => {
            const selectedStatuses = selectedOptions.map(option => option.status);
            changeFilters({ state: selectedStatuses });
          }}
        />
        </label>
        {currentUser.user_status === 'superuser' &&
        <Switcher
            checked={filters.isMine}
            onGx-change={() => changeFilters({isMine: !filters.isMine})}
            className={styles['switcher']}>
          {filters.isMine ?  'Мои' : 'Все' }
        </Switcher>
        }
        <GxButton className={classnames(styles['button'], styles['button--create_task'])} onClick={handleClickResetFilters}>
          <span>Сбросить все фильтры</span>
        </GxButton>
        <GxButton className={classnames(styles['button'], styles['button--reset-filters'])} onClick={() => navigate('/create-task')} >
          <GxIcon className={styles['button--icon_create']} src={PencilIcon} />
          <span>Создать задачу</span>
        </GxButton>
      </>
    );
  }

  return (
    <>
      <div className={styles['header']}>
        <Burger/>
        <span className={styles['header--title']}>Задачи</span>
      </div>
      <div className={styles['panel']}>
        <div className={styles['panel--wrapper']}>
          <div className={styles['panel__left-group']}>
            <GxDropdown className={styles['dropdown_mobile']} distance={12}>
              <GxIcon src={SettingsIcon} className={styles['dropdown_mobile--icon']} slot='trigger' />
              <GxMenu className={styles['dropdown_mobile--menu']}>
                <span className={styles['dropdown_mobile--subtitle']}>Поиск и фильтр задач</span>
                <GxMenuDivider />
                <Filters />
                {currentUser.user_status === 'superuser' && <FiltersDate />}
              </GxMenu>
            </GxDropdown>
            <div className={styles['panel__left-group--container']}>
              <Filters />
            </div>
          </div>
        </div>
        {isDesktopOrLaptop && currentUser.user_status === 'superuser' && <FiltersDate />}
      </div>

      {children({})}
    </>
  );

};

export default FiltersOverlay;
